module.exports = __webpack_public_path__ + "static/img/2.c2003cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/UltralowTemperature/R508B/2.jpg
// module id = c/q0
// module chunks = 1